/**
 * Cópia de valores SENSÍVEIS para o clipboard: tenta a API assíncrona
 * (navigator.clipboard, só em contexto seguro) e cai no execCommand('copy')
 * legado. Nunca loga nem persiste o valor. Retorna se conseguiu copiar.
 */
export async function copyText(text: string): Promise<boolean> {
  if (typeof navigator.clipboard?.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      /* sem permissão/foco — tenta o fallback abaixo */
    }
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    return ok;
  } catch {
    return false;
  }
}
